import { useEffect, useState } from "react";
import Subscribe from "../APIController/Subscribe";
import Table from "./Table";

const SubscriptionTable = () => {
    const [plans, setPlans] = useState([])
    const { getPlans } = Subscribe();

    useEffect(() => {
        handlePlanFetch()
    }, [])

    async function handlePlanFetch(){
        const data = await getPlans()
        setPlans(data.sort((a, b) => a.price - b.price))
    }

    if (plans.length === 0) return null;

    return (
        <Table
            headerRow={["Features", ...plans.map(plan => plan.name)]}
            columnValues={[
                ["Monatlicher Preis", ...plans.map(plan => `${plan.price} CHF`)],
                ["Produktgruppen", ...plans.map(plan => plan.categoriesCount)],
                ["Produkte je Produktgruppe", ...plans.map(plan => plan.productsPerCategory)],
                ["Zum Workspace einladbare Nutzer", ...plans.map(plan => plan.employeesCount)],
                ["Kartenzahlung extra abrechnen", ...plans.map(plan => plan.useCard)],
                ["Lokale Verbindung mit Geräten", ...plans.map(plan => plan.useLocalConnection)],
                ["Coupons erstellen", ...plans.map(plan => plan.createCoupons)],
                ["Inventar Verwalten", ...plans.map(plan => plan.useInventoryManagement)],
                ["Kassen abrechnen", ...plans.map(plan => plan.allowCashierUserTracking)],
                ["Kasse mit Mitarbeiter Pin", ...plans.map(plan => plan.allowCashierUserTracking)],
                ["Time Tracking von Mitarbeitern", ...plans.map(plan => plan.allowTimeTracking)],
            ]}
        />
    );
}
export default SubscriptionTable